import { useEffect, useState } from 'react';
import { getUserAssociatedProperties } from 'src/services/client';
import { ICalcomApiResult, IUserAssociatedProperty } from 'src/pages/Calendar/CalcomIntegration/types';

export interface IUseUserAssociatedProperties {
  properties: IUserAssociatedProperty[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useUserAssociatedProperties = (): IUseUserAssociatedProperties => {
  const [properties, setProperties] = useState<IUserAssociatedProperty[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProperties = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    const result: ICalcomApiResult<IUserAssociatedProperty[]> =
      await getUserAssociatedProperties();

    if (!result.ok) {
      setError(result.error ?? 'Failed to fetch your properties');
      setIsLoading(false);
      return;
    }

    setProperties(result.data ?? []);
    setIsLoading(false);
  };

  useEffect(() => {
    void fetchProperties();
  }, []);

  return { properties, isLoading, error, refetch: fetchProperties };
};